module.exports = __webpack_public_path__ + "media/application/images/svgs/chevrons-right-00cac2af3b687a184651c3695e938f60.svg";